<template>
  <div id="upload_list">
    <ul class="upload_list_ul">
      <li class="upload_list_ul_li" v-for="(item, index) in uploadFileList" :key="index">
        <div class="content_wrap" :ref="`content_wrap_${index}`">
          <div v-if="ofdFlag(item)" style="    width: 100px;" >
            <a :href="`${onlineUrl}/mk-leads/common/attach/download-file/${item.hashCode}`" style="color: rgb(6, 110, 183) !important;"><single-component v-if="widths>0"   :widths="widths" :index="index" :content="item.originalName" /></a>
          </div>
          <div v-else>
            <single-component v-if="widths>0" @click.native="download(item)"  :widths="widths" :index="index" :content="item.originalName" />
          </div>
        </div>
      </li>
    </ul>

    <!--预览图片-->
    <PreviewPicture
      :previewData="previewData"
      :pictureUrl="pictureUrl"
      :previewPictureDialogVisible="previewPictureDialogVisible"
      :isWm="false"
      @closePreviewPicture="closePreviewPicture"
    />
    <!--预览pdf-->
    <previewPdf
      :previewData="previewData"
      :previewPdfDialogVisible="previewPdfDialogVisible"
      :pdfUrl="pdfUrl"
      @closePreviewPdf="closePreviewPdf"
    />
  </div>
</template>
<script>
import SinglePermissionComponent from './single_permission.vue';
// import { leadsCommonAttachDel } from '@/utils/api/api';
// import urls from '@/utils/baseUrl';
import { onlineUrl } from '@/utils/config.js'
import PreviewPicture from '@/components/common/upload/previewPicture.vue';
import PreviewPdf from '@/components/common/upload/previewPdfInvoice.vue';

export default {
  props: {
    uploadFileList: {
      default: [],
      type: Array,
    },
    filesprogress:{
      default: true,
      type: Boolean,
    },
    isWm:{
      default: true,
      type: Boolean,
    },
    isEnableDownload:{
      default: true,
      type: Boolean,
    },
  },
  components: {
    'single-component': SinglePermissionComponent,
    PreviewPicture,
    PreviewPdf,
  },
  data() {
    return {
      ins:-1,
      widths:0,
      // urls:urls,
      previewData:{},
      pictureUrl:'',
      previewPictureDialogVisible:false,
      pdfUrl:'',
      previewPdfDialogVisible:false,
      onlineUrl:onlineUrl,
    }
  },
  methods: {
    ofdFlag(command){
      if( command.originalName.indexOf(".ofd") !== -1 ||
          command.originalName.indexOf(".OFD") !== -1)
      {
        return true
      }else{
        return false
      }
    },
    handleCommandPreview(command){
      console.log('command', command);
      if (
        command.originalName.indexOf(".pdf") !== -1 ||
        command.originalName.indexOf(".PDF") !== -1
      ) {
        if(command.isCurrentUpload){
            this.pdfUrl = this.isWm?`${this.onlineUrl}/mk-leads/common/attach/preview-temp-file/${command.hashCode}?wm=1`:`${this.onlineUrl}/mk-leads/common/attach/preview-temp-file/${command.hashCode}`
            this.previewPdfDialogVisible = true;
        }else{
            this.pdfUrl= this.isWm?`${this.onlineUrl}/mk-leads/common/attach/preview-file/${command.hashCode}?wm=1`:`${this.onlineUrl}/mk-leads/common/attach/preview-file/${command.hashCode}`
            this.previewPdfDialogVisible = true;
        }
      } else {
        if(command.isCurrentUpload!=undefined&&command.isCurrentUpload){
          this.pictureUrl = `${this.onlineUrl}/mk-leads/common/attach/preview-temp-file/${command.hashCode}`;
        }else{
          this.pictureUrl = `${this.onlineUrl}/mk-leads/common/attach/preview-file/${command.hashCode}`;
        }
        this.previewPictureDialogVisible = true;
      }
      this.previewData = command;
      console.log(this.pictureUrl)
    },
    closePreviewPicture() {
      this.previewPictureDialogVisible = false;
    },
    closePreviewPdf() {
      this.previewPdfDialogVisible = false;
    },
    getWidth(refs) {
      this.$nextTick(() => {
        const refStr = this.$refs[refs]
        if (refStr) {
          this.widths = refStr[0].offsetWidth || 0;
        }
      });
    },
    download(item) {
      if (item.progress === 100||!this.filesprogress) {
          // 上传成功才可下载
          // this.cal.downloadFileFun(item.url);
          this.handleCommandPreview(item);
      }
    }
  },
  mounted() {
    // this.overWidth(this.index);
    this.getWidth('content_wrap_0');
  },
}
</script>
<style lang="scss" scoped>
#upload_list{
  >.upload_list_ul{
    width: auto;
    >.upload_list_ul_li{
      >.content_wrap{
        font-size: 14px;
        line-height: 18px;
        padding:  0 4px;
        display: flex;
        align-items: center;
        text-align: left;
        >i.el-icon-document{
          color: #333;
          vertical-align: top;
          line-height: 18px;
          margin-right: 4px;
        }
        >i.el-icon-success,
        >i.el-icon-error{
          float: right;
          vertical-align: middle;
          line-height: 18px;
        }
        >i.el-icon-success{
          color: #67C23A;
        }
        >i.el-icon-error{
          color: #F56C6C;
        }
        >span{
          cursor: pointer;
          display: inline-block;
          margin-left: 4px;
          // max-width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        >.file_name:hover{
          color: #409EFF;
          text-decoration: underline;
        }
      }
      >.content_wrap:hover{
        background: rgba(0,0,0,.035);
      }
    }
  }
}
</style>